import {
  Box,
  Button,
  CircularProgress,
  Pagination,
  Paper,
  Skeleton,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { baseImageUrl } from '../../../../api';
import { reducerPaths } from '../../../../app/reducerPaths';
import '../../../../i18n';
import theme from '../../../../theme';
// import theme from '../../../theme';
import { setAlertDialog } from '../../../../toolkit/alertDialog/alertDialogSlice';
import { setCarEstimateVehicleId, setImages } from '../../../../toolkit/carEstimate/carEstimateSlice';
import { useLazyGetRecentlyAddedCarsQuery } from '../../../../toolkit/myGarage/myGarageApi';
import { resetMyGarageSlice, setActiveStep, setSelectedVehicle } from '../../../../toolkit/myGarage/myGarageSlice';
import { useLazyRelistCarQuery } from '../../../../toolkit/sellMyCar/sellMyCarApi';
import { MyGarageSteps } from '../../../../utils/constants/myGarage';
import { routes } from '../../../../utils/constants/routes';
import { carContainerTypes } from '../../../../utils/constants/ui/carContainers';
import CarContainer1, { NormalCard } from '../../components/CarContainer1';
import CarsList from '../../components/CarsList';
import { useSetupEditCarHandler } from '../../components/MyGarage/customHooks/useSetupEditCarHandler';
import SellMyCar from '../../components/MyGarage/SellMyCar';
import { CAR_STATUS, CAR_STATUSES } from '../../../../utils/constants/carData';
import { useCancelAuctionHandler } from '../LiveAuction/customHooks/useCancelAuctionHandler';
import { setupAndNavigateToCarEstimateHandler } from '../../../../utils/methods/generalVehicleMethods';

const getParsedCarLabelStatus = ({
  car,
  value
}) => {
  const car_label_status = value === 2 ? CAR_STATUSES['sold-car'] : value === 1 ? CAR_STATUSES['unsold-car'] : car?.car_label_status;

  return {
    ...car,
    car_label_status
  };
};

const MyGarageCarsList = ({ onCarClick }) => {
  // Translation hook
  const { t } = useTranslation('myGarage');

  // useTheme for responsive design
  const muiTheme = useTheme();

  // Responsive breakpoints
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(muiTheme.breakpoints.between('sm', 'md'));

  // static data start...
  const pageTabs = React.useMemo(() => {
    return {
      view: 'view',
      sellNewCar: 'sellNewCar',
    };
  }, []);

  const paginationDataInit = React.useMemo(() => {
    return {
      current_page: 1,
    };
  }, []);
  // static data end...

  // useNavigate...
  const navigate = useNavigate();
  const location = useLocation();
  // useNavigate...

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  // useSelector start...
  const myGarage = useSelector((store) => store[reducerPaths.myGarage]);
  // useSelector end...

  // custom hooks start...
  const [getRecentlyAddedCarsApiHandler, getRecentlyAddedCarsApiData] = useLazyGetRecentlyAddedCarsQuery();
  const [relishCarApiHandler, relishCarApiData] = useLazyRelistCarQuery();

  const { setupEditCarHandler } = useSetupEditCarHandler();
  const { onCancelAuctionHandler } = useCancelAuctionHandler();
  // custom hooks end...

  const [value, setValue] = useState(0);
  const [pageTab, setPageTab] = React.useState(location?.state?.pageTab ?? pageTabs?.view);
  const [paginationData, setPaginationData] = React.useState(paginationDataInit);

  const params = React.useMemo(() => {
    return {
      page: paginationData?.current_page,
    };
  }, [paginationData?.current_page]);

  // Handlers start...
  const fetchPaginationDataHandler = async () => {
    if (value === 0) {
      await getRecentlyAddedCarsApiHandler({
        endpoint: `/myGarage/Seller/RecentlyAdded`,
        params,
      });
    } else if (value === 1) {
      await getRecentlyAddedCarsApiHandler({
        endpoint: `/myGarage/Seller/UnSoldCars`,
        params,
      });
    } else {
      await getRecentlyAddedCarsApiHandler({
        endpoint: `/myGarage/Seller/SoldCars`,
        params,
      });
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handlePageChange = (e, page) => {
    setPaginationData((paginationData) => {
      return {
        ...paginationData,
        current_page: page,
      };
    });
  };

  const getRemainingSeconds = (car) => {
    return 0;
  };

  const changeTabHandler = () => {
    setPageTab((pageTab) => {
      if (pageTab === pageTabs.sellNewCar) {
        return pageTabs.view;
      } else {
        return pageTabs.sellNewCar;
      }
    });
  };

  const relistCarHandler = async (car) => {
    const res = await relishCarApiHandler({
      Vehicle_Id: car?.Vehicle_Id,
    });

    if (res?.error || ('status' in res?.data && !res?.data?.status)) {
      dispatch(
        setAlertDialog({
          open: true,
          title: `Error!`,
          message: res?.data?.message || res?.data?.error?.message || `Some error occured!`,
        })
      );
    } else {
      setupAndNavigateToCarEstimateHandler({
        car,
        dispatch,
        navigate,
        images: myGarage?.forms?.gallery?.images,
      });

      // fetchPaginationDataHandler();
    }
  };

  // const setupAndNavigateToCarEstimateHandler = (car) => {
  //   console.log(`onSuccessCallback`, car);
  //   // if (myGarage?.isEditing) {
  //   //   setPageTab(pageTabs?.view);
  //   //   dispatch(resetMyGarageSlice());
  //   // } else {
  //   dispatch(setCarEstimateVehicleId(car?.Vehicle_Id ? car?.Vehicle_Id : myGarage?.vehicle_id));

  //   let images = [];
  //   for (let item in myGarage?.forms?.gallery?.images) {
  //     images.push(...(myGarage?.forms?.gallery?.images?.[item] || []));
  //   }

  //   dispatch(setImages(images?.filter((item) => item)));
  //   navigate(`${routes.dashboardNavigation}${routes.carEstimate}`);
  //   // setPageTab(pageTabs.view);
  //   // }
  // };
  // Handlers end...

  // useEffect start...
  React.useEffect(() => {
    (async () => {
      fetchPaginationDataHandler();
    })();
  }, [value, paginationData?.current_page, pageTab]);

  React.useEffect(() => {
    setPaginationData((paginationData) => {
      return {
        ...paginationData,
        current_page: 1,
      };
    });
  }, [value]);

  React.useEffect(() => {
    return () => {
      console.log(`resetMyGarageSlice`);
      dispatch(resetMyGarageSlice());
    };
  }, []);
  // useEffect end...

  return (
    <Box
      display={'flex'}
      width={'100%'}
      sx={{
        borderRadius: '24px',
        ...(!myGarage?.isEditing
          ? { height: { md: `calc(100vh - 92px)`, sm: `calc(100vh - 112px)`, xs: 'auto' } }
          : {}),
        position: 'relative',
      }}
    >
      {pageTab === pageTabs?.view ? (
        <>
          <Box
            sx={{
              flex: '1',
              display: 'flex',
              flexDirection: 'column',
              background: theme.palette.background.paper,
              borderRadius: '24px',
              width: '100%',
            }}
          >
            <Paper elevation={0} sx={{ borderRadius: '24px' }}>
              <Box sx={{ padding: { xs: 2, sm: 3, md: 3 } }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', lg: 'row' },
                    justifyContent: 'space-between',
                    alignItems: { xs: 'flex-start', lg: 'center' },
                    gap: { xs: 2, md: 1 },
                  }}
                >
                  {/* Title */}
                  <Typography
                    variant={'h1'}
                    sx={{
                      fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                      fontWeight: 600,
                      color: theme.palette.primary.main,
                      textWrap: 'nowrap',
                    }}
                  >
                    {t('title')}
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: { xs: 'column', sm: 'row' },
                      justifyContent: 'space-between',
                      gap: { xs: 1.5, sm: 2 },
                      width: { xs: '100%', md: 'auto' },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        border: '1px solid',
                        borderColor: 'border.main',
                        p: 0.5,
                        borderRadius: 2,
                        overflow: 'hidden',
                        width: { xs: '100%', sm: 'auto' },
                      }}
                    >
                      <Tabs
                        fullWidth
                        value={value}
                        onChange={handleChange}
                        variant={isMobile ? 'fullWidth' : 'standard'}
                        slotProps={{
                          indicator: { style: { display: 'none' } },
                        }}
                        sx={{
                          width: '100%',
                          '& .MuiTabs-flexContainer': {
                            height: '100%',
                          },
                          '& .MuiTab-root': {
                            color: 'text.primary',
                            padding: { xs: '0.5rem 0.75rem', sm: '0.75rem 1.5rem' },
                            fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },
                            textTransform: 'none',
                            fontWeight: 500,
                            minHeight: { xs: '36px', sm: '48px' },
                            minWidth: { xs: 'auto', sm: '120px' },
                            '&.Mui-selected': {
                              borderRadius: 2,
                              backgroundColor: 'primary.main',
                              color: 'white',
                            },
                          },
                        }}
                      >
                        <Tab label={t('tabs.recentlyAdded')} />
                        <Tab label={t('tabs.unsoldCars')} />
                        <Tab label={t('tabs.soldCars')} />
                      </Tabs>
                    </Box>
                    <Button
                      fullWidth={isMobile}
                      variant="contained"
                      color="primary"
                      sx={{
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 500,
                        px: { xs: 2, sm: 3 },
                        fontSize: { xs: '0.875rem', sm: '1rem' },
                        whiteSpace: 'nowrap',
                      }}
                      onClick={() => {
                        setPageTab(pageTabs?.sellNewCar);
                      }}
                    >
                      {t('buttons.sellNewCar')}
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Paper>

            <Box
              sx={{
                height: 'calc(100% - 96px)',
                overflowY: 'auto',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                scrollbarWidth: 'none !important' /* Firefox */,
                '-ms-overflow-style': 'none' /* IE and Edge */,
                padding: { xs: 2, sm: 3, md: 3 },
                marginBottom: { xs: 3, sm: 3, md: 3 },
              }}
            >
              {getRecentlyAddedCarsApiData?.isFetching ? (
                // Skeleton UI
                <Box sx={{ height: '100%', width: '100%' }}>
                  <Grid container spacing={{ xs: 2, sm: 2, md: 3 }}>
                    {[...Array(8)].map((_, index) => (
                      <Grid key={index} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                        <Box
                          sx={{
                            backgroundColor: theme.palette.background.paper,
                            borderRadius: 2,
                            padding: 2,
                            border: `1px solid ${theme.palette.divider}`,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                          }}
                        >
                          {/* Car image skeleton */}
                          <Box sx={{ position: 'relative', marginBottom: 2 }}>
                            <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 1.5 }} />

                            {/* Timer skeleton in top right */}
                            <Box
                              sx={{
                                position: 'absolute',
                                bottom: 8,
                                right: 8,
                              }}
                            >
                              <Skeleton variant="rectangular" width={130} height={40} sx={{ borderRadius: 1 }} />
                            </Box>
                          </Box>

                          {/* Car details skeleton */}
                          <Box sx={{ marginBottom: 2 }}>
                            {/* Car title */}
                            <Skeleton variant="text" width="80%" height={24} sx={{ marginBottom: 1 }} />

                            {/* VIN */}
                            <Skeleton variant="text" width="60%" height={16} sx={{ marginBottom: 1 }} />

                            {/* Car specs grid */}
                            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, marginBottom: 2 }}>
                              {[...Array(4)].map((_, specIndex) => (
                                <Box key={specIndex}>
                                  <Skeleton variant="text" width="50%" height={14} sx={{ marginBottom: 0.5 }} />
                                  <Skeleton variant="text" width="70%" height={16} />
                                </Box>
                              ))}
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              ) : getRecentlyAddedCarsApiData?.data?.Vehicle?.data?.length === 0 ? (
                <Typography
                  sx={{
                    fontWeight: '500',
                    fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2rem' },
                    textAlign: 'center',
                    marginTop: { xs: '-100px', md: '-200px' },
                  }}
                >
                  {t('messages.noDataFound')}
                </Typography>
              ) : (
                <Box
                  sx={{
                    height: '100%',
                    width: '100%',
                    padding: { xs: 0, sm: 0 },
                  }}
                >
                  <CarsList
                    showRemainingTime={false}
                    cars={getRecentlyAddedCarsApiData?.data?.Vehicle?.data?.map?.((vehicle) => {
                      return {
                        ...vehicle,
                        showRelist: value === 1 && vehicle?.car_label_status === CAR_STATUSES['unsold-car'],
                        car_label_status: value === 2 ? CAR_STATUSES['sold-car'] : (value === 1 && vehicle?.car_label_status !== CAR_STATUSES['relist-pending']) ? CAR_STATUSES['unsold-car'] : vehicle?.car_label_status,
                        showEditAuction: (value === 0) && (
                          vehicle?.car_label_status === CAR_STATUSES.approval_pending ||
                          vehicle?.car_label_status === CAR_STATUSES['live-in-auction'] || 
                          vehicle?.car_label_status === CAR_STATUSES['listed-to-auction']
                        ) && (vehicle?.Live_Auction_DateTime || vehicle?.Buy_now_DateTime),
                        showListToAuction: (value === 0 && vehicle?.car_label_status === CAR_STATUSES['list-to-auction']) || (value === 1 && vehicle?.car_label_status === CAR_STATUSES['relist-pending']),
                        onEditAuction: (car) => {
                          setupAndNavigateToCarEstimateHandler({
                            car: getParsedCarLabelStatus({ car }),
                            dispatch,
                            navigate,
                            images: myGarage?.forms?.gallery?.images,
                          });
                        },
                        onListToAuction: (car) => {
                          setupAndNavigateToCarEstimateHandler({
                            car: getParsedCarLabelStatus({ car }),
                            dispatch,
                            navigate,
                            images: myGarage?.forms?.gallery?.images
                          });
                        },
                        vin: vehicle?.VIN,
                        year: vehicle?.Year,
                        make: vehicle?.Make,
                        model: vehicle?.Model,
                        odometer: vehicle?.Mileage,
                        image: vehicle?.Exterior_Image
                          ? `${baseImageUrl}/${vehicle?.Vehicle_Id}/${vehicle?.Exterior_Image}`
                          : ``,
                      };
                    })}
                    isGarageCar
                    Component={CarContainer1}
                    ChildComponent={NormalCard}
                    showEdit={value === 0 || value === 1}
                    onEdit={(car, cb) => {
                      setupEditCarHandler(
                        getParsedCarLabelStatus({ car }), 
                        cb
                      );
                    }}
                    onEditCb={(car) => {
                      dispatch(
                        setSelectedVehicle({
                          selectedVehicle: getParsedCarLabelStatus({ car }),
                        })
                      );
                      dispatch(setActiveStep(MyGarageSteps[0]));
                      setPageTab(pageTabs?.sellNewCar);
                    }}
                    onRelistListToAuctionCb={(car) => {
                      dispatch(
                        setSelectedVehicle({
                          selectedVehicle: getParsedCarLabelStatus({ car }),
                        })
                      );
                      setupAndNavigateToCarEstimateHandler({
                        car: getParsedCarLabelStatus({ car }),
                        dispatch,
                        navigate,
                        images: myGarage?.forms?.gallery?.images,
                      });
                    }}
                    onRelist={relistCarHandler}
                    timerRemainingSecondsHandler={getRemainingSeconds}
                    cardType={carContainerTypes.MY_GARAGE}
                    onClick={(car) => {
                      if (onCarClick) {
                        onCarClick(
                          getParsedCarLabelStatus({ car }), 
                          value === 1 ? CAR_STATUS.UNSOLD_CAR : value === 2 ? CAR_STATUS.SOLD_CAR : null
                        );
                      }
                    }}
                    showCancelAuction={value === 0}
                    onCancelAuction={onCancelAuctionHandler}
                    RelistButton={{
                      component: ({ car }) => {
                        return (
                          <Button
                            sx={{
                              color: theme.palette.text.secondary,
                            }}
                            onClick={() => {
                              if (car?.Relist_Count >= 5) {
                                dispatch(
                                  setAlertDialog({
                                    open: true,
                                    title: `Error!`,
                                    message: `This car cannot be listed again.`,
                                  })
                                );
                                return;
                              }

                              if (relistCarHandler) {
                                relistCarHandler(getParsedCarLabelStatus({ car }));
                              }
                            }}
                            disabled={relishCarApiData?.isFetching}
                          >
                            {relishCarApiData?.isFetching ? (
                              <CircularProgress
                                size={22}
                                sx={{
                                  color: theme.palette.background.paper,
                                }}
                              />
                            ) : (
                              t('relist')
                            )}
                          </Button>
                        );
                      },
                    }}
                  />
                </Box>
              )}
            </Box>
          </Box>
          {getRecentlyAddedCarsApiData?.data?.Vehicle?.data?.length > 0 ? (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                position: 'absolute',
                bottom: '0px',
                padding: { xs: 1, sm: 0 },
              }}
            >
              <Pagination
                count={getRecentlyAddedCarsApiData?.data?.Vehicle?.last_page}
                page={getRecentlyAddedCarsApiData?.data?.Vehicle?.current_page || paginationData?.current_page}
                onChange={handlePageChange}
                size={isMobile ? 'small' : 'medium'}
                siblingCount={isMobile ? 0 : isTablet ? 1 : 1}
                boundaryCount={isMobile ? 1 : 2}
              />
            </Box>
          ) : null}
        </>
      ) : (myGarage?.isEditing && myGarage?.areEditFormsSet) || !myGarage?.isEditing ? (
        <SellMyCar changeTabHandler={changeTabHandler} onSuccessCallback={setupAndNavigateToCarEstimateHandler} />
      ) : null}
    </Box>
  );
};

export default MyGarageCarsList;
